document.addEventListener("DOMContentLoaded", function () {
    const showroomButton = document.querySelector(".showroom-button a.btn");

    if (showroomButton) {
        showroomButton.addEventListener("click", function (event) {
            event.preventDefault(); // Zabráni predvolenému správaniu odkazu

            const targetElement = document.querySelector(".map-wrapper");
            if (targetElement) {
                const offset = 100; // Posun o 100px vyššie (prispôsob podľa potreby)
                const elementPosition = targetElement.getBoundingClientRect().top + window.scrollY;
                const offsetPosition = elementPosition - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });

                history.pushState(null, null, "#map-info-card"); // Pridanie hash do URL
            }
        });
    }
});